<template>
  <component :is="component" />
</template>

<script>
import RegisterNewUserTemplate from "@/app/register/components/templates/RegisterNewUserTemplate.vue";
import RegisterNewUserPasswordTemplate from "@/app/register/components/templates/RegisterNewUserPasswordTemplate.vue";
import { defineComponent } from "vue";
import httpManager from "@/app/shared/utils/httpManager";
export default defineComponent({
  components: {
    RegisterNewUserTemplate,
    RegisterNewUserPasswordTemplate,
  },
  created() {
    // localStorage.clear();
    let subdomain = localStorage.getItem("workspace");

    if (!subdomain) {
      subdomain = window.location.host.split(".")[0];
      localStorage.setItem("workspace", subdomain);
    }

    httpManager.updateBaseURL(`https://${subdomain}.backend.${import.meta.env.VITE_HOSTNAME}`);
  },
  computed: {
    component() {
      let step = this.$store.getters["getRegisterStep"];
      let name = "register-new-user";

      if (this.$route.query.changePassword === "true") step = 2;

      switch (step) {
        case 2:
          name = "register-new-user-password";
          break;
        default:
          break;
      }
      return `${name}-template`;
    },
  },
});
</script>
